import React from "react"

export type Direction = "ltr" | "rtl"

export interface Locale {
  // of format ab_XY
  locale: string
  direction: Direction
}

export function getLocaleDirection(locale: string): Direction {
  return /^(ar|he|iw|fa|ur|yi)_/.test(locale) ? "rtl" : "ltr"
}

export function createLocale(locale: string): Locale {
  return { locale, direction: getLocaleDirection(locale) }
}

export function isRtl(locale: Locale): boolean {
  return locale.direction === "rtl"
}

export function isHebrew(locale: Locale): boolean {
  return /^(he|iw)_/.test(locale.locale)
}

const LOCALE_FORMAT = /^([a-z]{2})_([A-Z]{2})$/

export function parseLocale(locale: string): null | {
  language: string
  region: string
} {
  const result = LOCALE_FORMAT.exec(locale)
  if (result) {
    return {
      language: result[1],
      region: result[2],
    }
  }
  return null
}

export const defaultLocale: Locale = createLocale("en_US")

export const LocaleContext = React.createContext<Locale>(defaultLocale)

LocaleContext.displayName = "LocaleContext"
